import { createFileRoute } from '@tanstack/react-router';
import DeviceGroups from 'containers/DeviceGroups';

export const Route = createFileRoute('/_authenticated/deviceGroups')({
  component: DeviceGroups,
});
